import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'

let Commments = null

class CommentsLoader extends Component {
  constructor (props) {
    super(props)
    this.state = { loaded: false }
  }

  componentDidMount () {
    this.updateBundles(this.props, this.state)
  }

  componentDidUpdate () {
    if (process.env.BROWSER) {
      this.updateBundles(this.props, this.state)
    }
  }

  setLoaded = (loaded) => {
    this.setState(() => ({ loaded }))
  }

  updateBundles = async (props, state) => {
    const { loaded } = state
    const { comments } = props
    if (!loaded && comments.get('visible')) {
      const { default: loadedComponent } = await import('../Comments/index')
      Commments = loadedComponent
      this.setLoaded(true)
    }
  }

  render () {
    const {
      auth,
      comments,
      contentId,
      setCommentsVisible,
      onClickClose,
      location,
    } = this.props
    const { loaded } = this.state
    const key = loaded ? 0 : 1
    if (loaded && Commments) {
      return (
        <Commments
          key={`comments-loader-comments-${key}`}
          auth={auth}
          comments={comments}
          contentId={contentId}
          setCommentsVisible={setCommentsVisible}
          onClickClose={onClickClose}
          location={location}
        />
      )
    }
    return null
  }
}

CommentsLoader.propTypes = {
  comments: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setCommentsVisible: PropTypes.func.isRequired,
  onClickClose: PropTypes.func,
  location: PropTypes.object,
}

export default connectRedux(
  (state) => ({
    auth: state.auth,
    comments: state.comments,
    contentId: state.comments.get('contentId'),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setCommentsVisible: actions.comments.setCommentsVisible,
    }
  },
)(CommentsLoader)
